import { Request } from  'common/domain/models/request';

class TeamRequestsFormatter {
  constructor() {
  }

  formatReject(request) {
    let params = [];
    let requestFormmated = this.formatRequest(request);
    requestFormmated.action = Request.ACTIONS.REJECT;
    params.push(requestFormmated);
    return params;
  }

  formatApproveAll(requests) {
    let params = [];
    requests.forEach((request) => {
      let requestApproved = this.formatApprove(request);
      params.push(requestApproved[0]);
    });
    return params;
  }

  formatApprove(request) {
    let params = [];
    let requestFormmated = this.formatRequest(request);
    requestFormmated.action = Request.ACTIONS.APPROVE;
    params.push(requestFormmated);
    return params;
  }

  formatRequest(request) {
    return {
      employeeId : request.employeeId,
      startDate  : request.startDate,
      endDate    : request.endDate,
      code       : request.code
    };
  }

  formatDiscard(request) {
    let params = this.formatRequest(request);
    delete params.endDate;
    return params;
  }

  formatRequestInfo(request, formatDateForView, daysLiteral, hoursLiteral) {
    if (request.hours) {
      return `
        <h1>${request.name}</h1>
        <p>${request.periodType} - ${request.category}</p>
        <p>${formatDateForView(request.startDate)}</p>
        <p>(${request.hours} ${hoursLiteral})</p>
      `;
    }

    return `
      <h1>${request.name}</h1>
      <p>${request.periodType} - ${request.category}</p>
      <p>${formatDateForView(request.startDate)}</p><p> ${formatDateForView(request.endDate)}</p>
      <p>(${request.duration} ${daysLiteral})</p>
    `;
  }
}

export default TeamRequestsFormatter;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequests.formatters.js